import apiRequest from "../../helpers/apiRequest";

export default async (obj) => {
    return await apiRequest({
        method: 'post',
        url: `subscriptions/coupon/validation/`,
        data: obj
    })
}
